import { type IApiResponse } from '@/helpers/types';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

interface ICollationOfficer {
	id: number;
	userId: number;
	wardId: number;
}
const collationOfficerApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createCollationOfficer: builder.mutation<IApiResponse, Omit<ICollationOfficer, 'id'>>({
			query: (body) => ({
				method: 'POST',
				url: '/CollationOfficer',
				body,
			}),
		}),
		getCollationOfficier: builder.query<IApiResponse, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/CollationOfficer${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
		getCollationOfficierById: builder.query<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/CollationOfficer/${id}`,
			}),
		}),
		updateCollationOfficier: builder.mutation<IApiResponse, ICollationOfficer>({
			query: (body) => ({
				url: '/CollationOfficer/update',
				method: 'PUT',
				body,
			}),
		}),
		deleteCollationOfficer: builder.mutation<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/CollationOfficer/delete/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useCreateCollationOfficerMutation,
	useDeleteCollationOfficerMutation,
	useGetCollationOfficierByIdQuery,
	useGetCollationOfficierQuery,
	useUpdateCollationOfficierMutation,
} = collationOfficerApiSlice;
